var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-container"},[_c('div',{staticClass:"login-box"},[_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa"}}),_c('p',{staticClass:"login-text"},[_vm._v("登录中...")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }